// schema
import * as ISchema from "@schema";

// libraries
import * as React from "react";
import { Dialog, Button, CircularProgress as MuiCircularProgress } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import { createFragmentContainer, QueryRenderer, ReadyState } from "react-relay";

// components
import { TeamJoinCreate } from "@components/team-join-create";
import { CircularProgress } from "@clockwise/web-commons/src/components/circular-progress";

// util
import { track, TrackingEvents, trackFSEvent } from "@util/analytics.util";

// internal
import { IProps, IState } from "./TeamJoinCreateDialog.d";
import { styles } from "./TeamJoinCreateDialog.styles";
import { fragments, query } from "./TeamJoinCreateDialog.gql";

class TeamJoinCreateDialogComponent extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      saving: false,
      isValid: false,
      currentView: "create",
    };
  }

  ///////////////
  // Listeners //
  ///////////////

  public onInit = ({
    nDisplayedTeams,
    nSuggestedTeams,
    nDisplayedInviteSuggestions,
  }: {
    nDisplayedTeams: number;
    nSuggestedTeams: number;
    nDisplayedInviteSuggestions: number;
  }) => {
    track(TrackingEvents.TEAMS.TEAM_SETTINGS_TEAM_CREATE_JOIN_SHOWN, {
      nDisplayedTeams,
      nSuggestedTeams,
      nDisplayedInviteSuggestions,
    });
  };

  ///////////////
  // Lifecycle //
  ///////////////

  public UNSAFE_componentWillMount() {
    trackFSEvent(TrackingEvents.TEAMS.TEAM_SETTINGS_TEAM_CREATE_JOIN_SHOWN);
  }

  ///////////////
  // Rendering //
  ///////////////
  private renderDialogContents = (viewer: ISchema.IViewer | null) => {
    const { classes, org } = this.props;

    if (!viewer) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <TeamJoinCreate
        viewer={viewer}
        org={org}
        mode={this.props.mode}
        analyticsMode={this.props.mode}
        onInit={this.onInit}
        onChangeJoinMode={() => null}
        onChangeValidity={(isValid) => this.setState({ isValid })}
        onChangeView={(currentView) => this.setState({ currentView })}
        onSave={this.props.onClose}
        save={this.state.saving}
        forcedInitialView={this.props.forcedInitialView}
        selectMode={this.props.selectMode}
      />
    );
  };

  public render() {
    const { open, onClose, org, classes, selectMode } = this.props;
    const { currentView, isValid } = this.state;

    return (
      <QueryRenderer
        variables={{
          orgRelayId: org.id,
          myCalendarIds: [org.primaryOrgCalendar],
          excludeMyTeams: !selectMode,
        }}
        query={query}
        environment={this.props.relay.environment}
        render={(readyState: ReadyState) => {
          const viewer: ISchema.IViewer = readyState.props && readyState.props.viewer;

          return (
            <Dialog open={open} onClose={() => onClose()}>
              <div className={classes.dialog}>{this.renderDialogContents(viewer)}</div>
              <div className={classes.buttons}>
                <Button onClick={() => onClose()}>Cancel</Button>
                <Button
                  color="primary"
                  disabled={!isValid || this.state.saving}
                  onClick={() => this.setState({ saving: true })}
                >
                  {this.state.saving ? (
                    <MuiCircularProgress size={24} style={{ marginRight: 4 }} />
                  ) : currentView === "join" && !selectMode ? (
                    "Join Team"
                  ) : currentView === "create" ? (
                    "Create Team"
                  ) : (
                    "Select Team"
                  )}
                </Button>
              </div>
            </Dialog>
          );
        }}
      />
    );
  }
}

/////////////////
// With Styles //
/////////////////

export const TeamJoinCreateDialogWithStyles = withStyles(styles)(TeamJoinCreateDialogComponent);

///////////
// Relay //
///////////

export const TeamJoinCreateDialog = createFragmentContainer(
  TeamJoinCreateDialogWithStyles,
  fragments,
);
